export default function capabilitiesButton(props) {
  // RETURNS A TEMPLATE BUTTON FOR CAPABILITIES
  return (
    <div className="capabilitiesButton fsXS bold uppercase transition pointer">
      <h3>{props.name}</h3>
    </div>
  );
}
